enum DexfNotificationTypeEnum {
	email = 'email',
	sms = 'sms'
}

export default DexfNotificationTypeEnum;
